import { useDynamicScript } from '~/App/shared/hooks/useDynamicScript';
import { googleRecaptchaSource } from '~/config/dynamicScriptsTags';

export const useRecaptcha = () => useDynamicScript(googleRecaptchaSource);
